import React from 'react'
import { store } from '../../../store'
import Rolling from '../../../Images/rolling.svg';

class ChangeTheme extends React.Component {
constructor() {
	super()
	this.state = {
		theme: '',
		hidebtn: false
	}
}
componentDidMount() {
	this.setState({theme: store.getState().website.template})
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
}
resize() {
    this.setState({hidebtn: window.innerWidth <= 760});
}
	render(props) {
const changeTemplate = (theme) => {
		this.props.onTemplate(theme)
		this.setState({
			theme: theme
		})
}
const toCreate = () => {
	this.props.onWebsiteStatus('processing')
	setTimeout(
		function() {
			this.props.onRouteChange(this.state.theme)
			this.props.toMake(true)
		}
	.bind(this),
	500
	)
}
		return (
			<div>
			<div className="settings_theme_outer" onMouseOver={this.props.onClickInside} onMouseOut={this.props.onClickOutside}>
			<span onClick={()=>this.props.onOpen('')} href="#" className="close closepanel"/></div>
			<div className="settings_theme_inner" onMouseOver={this.props.onClickInside} onMouseOut={this.props.onClickOutside}>
			<div className="settings_theme_head">
			<div className="settings_theme_head1"><h3><strong>Select a Theme</strong></h3></div>
			<div className="settings_theme_head2">
			{!this.state.hidebtn
				?	<button className="top_btn" onClick={toCreate.bind(this)}>
					{this.props.websiteStatus === 'processing'
					?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
					: null
					}
					{!this.props.websiteStatus
					?<span>Customize & Save</span>
					: null
					}
					</button>
				: null
			}
          </div>
          </div>
          <div className="fullpage_theme">
          <div className="themes">
          
             <div className="theme_select" onClick={(theme)=>changeTemplate('fourth')}>
             <div className={
              this.state.imgfirst === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgfirst: 'loaded'})} className={
              this.state.theme === 'fourth'
              ? 'theme_img_active'
              : 'theme_img'
              } src={`${process.env.REACT_APP_API}/img/fourth.jpg`} alt="theme_img" />
             </div>
             </div>

             <div className="theme_select" onClick={(theme)=>changeTemplate('fifth')}>
             <div className={
              this.state.imgfirst === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgfirst: 'loaded'})} className={
              this.state.theme === 'fifth'
              ? 'theme_img_active'
              : 'theme_img'
              } src={`${process.env.REACT_APP_API}/img/fifth.jpg`} alt="theme_img" />
             </div>
             </div>
          </div>
			<div  className="themes">
            <div className="theme_select" onClick={(theme)=>changeTemplate('first')}>
             <div className={
              this.state.imgfirst === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
            	}>
             <img onLoad={()=> this.setState({imgfirst: 'loaded'})} className={
              this.state.theme === 'first'
              ? 'theme_img_active'
              : 'theme_img'
            	} src={`${process.env.REACT_APP_API}/img/first.jpg`} alt="theme_img" />
             </div>
             </div>
             <div className="theme_select" onClick={(theme)=>changeTemplate('second')}>
             <div className={
              this.state.imgsecond === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
            	}>
             <img onLoad={()=> this.setState({imgsecond: 'loaded'})} className={
              this.state.theme === 'second'
              ? 'theme_img_active'
              : 'theme_img'
            	}  src={`${process.env.REACT_APP_API}/img/second.jpg`} alt="theme_img" />
             </div>
             </div>
             </div>
			<div  className="themes">
             <div className="theme_select" onClick={(theme)=>changeTemplate('third')}>
             <div className={
              this.state.imgfirst === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
            	}>
             <img onLoad={()=> this.setState({imgfirst: 'loaded'})} className={
              this.state.theme === 'third'
              ? 'theme_img_active'
              : 'theme_img'
            	} src={`${process.env.REACT_APP_API}/img/third.jpg`} alt="theme_img" />
             </div>
             </div>
             <div className="theme_select">
             </div>
             </div>
             </div>
             {this.state.hidebtn
				?	<div align="center">
					<button className="top_btn frm" onClick={toCreate.bind(this)}>
					{this.props.websiteStatus === 'processing'
					?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
					: null
					}
					{!this.props.websiteStatus
					?<span>Customize & Save</span>
					: null
					}
					</button>
					</div>
				: null
			}
			</div>
			</div>
			)
	}
}

export default ChangeTheme